<div class="checkbox-container">
    <label [for]="id" class="checkbox-label">
        <input type="checkbox" [value]="value" (change)="onCheckboxChange($event)" [id]="id" [checked]="checked" [disabled]="disabled" />
        <span class="checkmark"></span>
        <ng-content></ng-content>
    </label>
</div>
